import { StateCreator } from "zustand";

export interface BasketSlice {
  basketOfferCountSnapshot: number | null;
  setBasketOfferCountSnapshot: (count: number | null) => void;
}

export const createBasketSlice: StateCreator<BasketSlice> = (set) => ({
  basketOfferCountSnapshot: null,
  setBasketOfferCountSnapshot: (count) =>
    set(() => ({
      basketOfferCountSnapshot: count,
    })),
});
